<template>
  <div>
    <side-menu/>
    <loading-screen v-if="loadingScreen"/>
    <section class="container profile-container">
      <div class="profile">
        <h1>Identidade de Saúde</h1>
        <card-health-id v-if="!loadingScreen && values" :data="values" />
      </div>
    </section>
  </div>
</template>

<script>
    import {GET_CUSTOMER, GET_CUSTOMER_RISKS} from '../../services/customer';
    import {LAST_ANSWERS} from '../../services/kit';

    import CardHealthId from '../../components/CardHealthId/CardHealthId';

    export default {
        components: {CardHealthId},
        data() {
            return {
                loadingScreen: true,
                values: {},
            }
        },
        methods: {
            async getData() {
                try {
                    const response = await GET_CUSTOMER();
                    this.values = response;

                    const risks = await GET_CUSTOMER_RISKS();
                    this.values.risks = risks;

                    const answers = await LAST_ANSWERS();
                    if(answers.data && answers.data.field_answers)
                        this.getAnswers(answers.data.field_answers);
                } catch(error) {
                    console.log(error);

                } finally {
                    this.loadingScreen = false;
                }
            },
            getAnswers(answers) {
                let height = null;
                let weight = null;
                answers.map(answer => {
                    if(answer.field.type == 'imc'){
                        weight = answer.response.weigth;
                        height = answer.response.heigth;
                    }
                })
                this.values.customer.height = height;
                this.values.customer.weight = weight;
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>
  @import "./health-id-digital.scss";

  .card {
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 1000px) {
    .container {
        margin-left: 0;
        padding-top: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/HealthIdDigital/HealthIdDigital.vue